import { StatTable } from "components/StatsTable/StatTable";
import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { Match } from "model/Match/Match";
import {
  calculateSmsSeasonRecords,
  SmsSeasonRecordWithDisplay,
} from "model/Records old/SmsSeasonRecord";
import { selectWithDisplay } from "./Shared";
import { useAppSelector } from "app/hooks";

interface Props {
  matches: Match[];
  rosterIds: string[];
  tournamentId: string;
}

export const SmsSeasonTable = ({ matches, rosterIds, tournamentId }: Props) => {
  const records = calculateSmsSeasonRecords(rosterIds, matches);
  const recordsWithDisplay = useAppSelector((state) =>
    selectWithDisplay(state, records, tournamentId)
  );

  const columns: StatTableColumn<SmsSeasonRecordWithDisplay>[] = [
    {
      type: "Position",
      sortable: false,
      positionGetter: (arg) => arg.record.position,
    },
    {
      type: "OrgLogoName",
      sortable: false,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.displayName,
    },
    {
      type: "Text",
      header: "W-L",
      title: "Win Loss Record",
      sortable: false,
      highlight: true,
      textGetter: (arg) => `${arg.record.wins} - ${arg.record.loses}`,
    },
    {
      type: "Text",
      header: "Map W-L",
      title: "Number Of Maps Won and Lost Across All Maps",
      sortable: false,
      textGetter: (arg) => `${arg.record.setsWon} - ${arg.record.setsLost}`,
    },
    {
      type: "Text",
      header: "Round W-L",
      title: "Number Of Rounds Won and Lost Across All Maps",
      sortable: false,
      textGetter: (arg) => `${arg.record.roundsWon} - ${arg.record.roundsLost}`,
    },
  ];

  return (
    <StatTable
      thinner={true}
      stats={recordsWithDisplay}
      columns={columns}
      keyGetter={(arg) => arg.displayName}
    />
  );
};
